import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CssBaseline, Box, Container, TextField, Button, MenuItem } from '@mui/material';

const theme = createTheme();
const LoginForm = ({ companies, formik, isMobileOS }) => {
  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              paddingBottom: theme.spacing(1),
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              //borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <img src="/static/images/logo/logo.svg" alt="logo" />
          </Box>
          <>
      <Box
        component="form"
        noValidate
        sx={{ mt: 1 }}
        onSubmit={formik.handleSubmit}
      >
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          name="username"
          label="Email"
          autoComplete="username" // [수정] 브라우저가 아이디 자동완성을 찌를 수 있도록 명시
          value={formik.values.username}
          onChange={formik.handleChange}
          error={formik.touched.username && Boolean(formik.errors.username)}
          helperText={formik.touched.username && formik.errors.username}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password" // 자동완성 연동용
          value={formik.values.password}
          onChange={formik.handleChange}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
        />
        <TextField
          id="outlined-select-currency"
          margin="normal"
          required
          fullWidth
          select
          label="Company"
          name="company"
          value={formik.values.company}
          onChange={formik.handleChange}
          error={formik.touched.company && Boolean(formik.errors.company)}
          helperText={formik.touched.company && formik.errors.company}
        >
          {companies &&
            companies.map((option) => (
              <MenuItem key={option.companyCd} value={option.companyCd}>
                {option.companyNm}
              </MenuItem>
            ))}
        </TextField>

        {isMobileOS && (
          <Button
            type="submit"
            fullWidth
            variant="contained"
            value="car" // [수정] 실제 매핑 데이터인 car 입력
            sx={{ 
              mt: 3, 
              mb: 0, 
              bgcolor: '#8b00ff',
              '&:hover': {
                bgcolor: '#6a00c8',
              }
            }}
            disabled={formik.isSubmitting}
            onClick={() => {
              formik.setFieldValue('loginType', 'car'); 
              try {
                localStorage.setItem('loginMode', 'car_service');
              } catch (e) {
                console.error('localStorage 저장 실패:', e);
              }
            }}
          >
            법인 차량 이용 로그인
          </Button>
        )}

        <Button
          type="submit"
          value="normal" // [수정] 빈 값 분기처리를 가로채기 위한 고유 식별자 지정
          fullWidth
          variant="contained"
          sx={{ mt: 3, mb: 2 }}
          disabled={formik.isSubmitting}
          onClick={() => {
            formik.setFieldValue('loginType', ''); 
            try {
              localStorage.removeItem('loginMode');
            } catch (e) {
              console.error('localStorage 삭제 실패:', e);
            }
          }}
        >
          Sign In
        </Button>
      </Box>
    </>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default LoginForm;
